<template>
  <div class="solution" :class="classBgc" style="height: 715px; width: 100vw">
    <div class="solution-cover">
      <div class="title">全场景全行业解决方案</div>
      <div class="content2">
        <div class="left">
          <div
            class="left-list"
            :class="classIndex == 1 ? 'left-active' : ''"
            @click="handleSwitch(1)"
          >
            知识付费
          </div>
          <div
            class="left-list"
            :class="classIndex == 2 ? 'left-active' : ''"
            @click="handleSwitch(2)"
          >
            兴趣培训
          </div>
          <div
            class="left-list"
            :class="classIndex == 3 ? 'left-active' : ''"
            @click="handleSwitch(3)"
          >
            大健康
          </div>
          <div
            class="left-list"
            :class="classIndex == 4 ? 'left-active' : ''"
            @click="handleSwitch(4)"
          >
            K12教育
          </div>
          <div
            class="left-list"
            :class="classIndex == 5 ? 'left-active' : ''"
            @click="handleSwitch(5)"
          >
            企业培训
          </div>
        </div>
        <div class="right" v-if="classIndex == 1">
          <div style="font-size: 24px; margin-bottom: 24px">
            系统化的知识交付与用户运营工具
          </div>
          <div style="color: #f5f8fa; font-size: 16px; margin-bottom: 40px">
            零门槛创建大米智课直播网校平台，多内容打包+督学工具，打造高质量的内容交付，丰富的营销工具，解决引转化难、退费多、复购难，助力企业打造规范化知识交付链路。
          </div>
          <div class="icon">
            <div
              style="
                display: flex;
                flex-direction: column;
                align-items: center;
                margin: 0 15px;
              "
            >
              <div class="img">
                <img
                  style="width: 146px; height: 146px"
                  src="../assets/official/Group 301@2x.png"
                  alt=""
                />
              </div>
            </div>
            <div
              style="
                display: flex;
                flex-direction: column;
                align-items: center;
                margin: 0 15px;
              "
            >
              <div class="img">
                <img
                  style="width: 146px; height: 146px"
                  src="../assets/official/Group 47994@2x.png"
                  alt=""
                />
              </div>
            </div>
            <div
              style="
                display: flex;
                flex-direction: column;
                align-items: center;
                margin: 0 15px;
              "
            >
              <div class="img">
                <img
                  style="width: 146px; height: 146px"
                  src="../assets/official/Group 47993@2x.png"
                  alt=""
                />
              </div>
            </div>
            <div
              style="
                display: flex;
                flex-direction: column;
                align-items: center;
                margin: 0 15px;
              "
            >
              <div class="img">
                <img
                  style="width: 146px; height: 146px"
                  src="../assets/official/Group 47995@2x.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div
            @click="inquiry()"
            style="
              background-color: #0274f7;
              height: 44px;
              width: 140px;
              border-radius: 2px;
              text-align: center;
              line-height: 44px;
              margin-top: 18px;
              cursor: pointer;
            "
          >
            立即咨询
          </div>
        </div>
        <div class="right" v-if="classIndex == 2">
          <div style="font-size: 24px; margin-bottom: 24px">
            提高内容传输效率，增加学习趣味
          </div>
          <div style="color: #f5f8fa; font-size: 16px; margin-bottom: 40px">
            作为技术服务商，我们致力于提供全面的知识培训平台解决方案，涵盖丰富的内容类型、多样化的服务形式以及深度的体验互动。我们的目标是为客户打造一个专属的知识培训生态系统，以满足不同行业和领域的兴趣培训需求
          </div>
          <div class="icon">
            <div
              style="
                display: flex;
                flex-direction: column;
                align-items: center;
                margin: 0 15px;
              "
            >
              <div class="img">
                <img
                  style="width: 146px; height: 146px"
                  src="../assets/official/Group 301@2x1.png"
                  alt=""
                />
              </div>
            </div>
            <div
              style="
                display: flex;
                flex-direction: column;
                align-items: center;
                margin: 0 15px;
              "
            >
              <div class="img">
                <img
                  style="width: 146px; height: 146px"
                  src="../assets/official/Group 47994@2x1.png"
                  alt=""
                />
              </div>
            </div>
            <div
              style="
                display: flex;
                flex-direction: column;
                align-items: center;
                margin: 0 15px;
              "
            >
              <div class="img">
                <img
                  style="width: 146px; height: 146px"
                  src="../assets/official/Group 47993@2x1.png"
                  alt=""
                />
              </div>
            </div>
            <div
              style="
                display: flex;
                flex-direction: column;
                align-items: center;
                margin: 0 15px;
              "
            >
              <div class="img">
                <img
                  style="width: 146px; height: 146px"
                  src="../assets/official/Group 47995@2x1.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div
            @click="inquiry()"
            style="
              background-color: #0274f7;
              height: 44px;
              width: 140px;
              border-radius: 2px;
              text-align: center;
              line-height: 44px;
              margin-top: 20px;
              cursor: pointer;
            "
          >
            立即咨询
          </div>
        </div>
        <div class="right" v-if="classIndex == 3">
          <div style="font-size: 24px; margin-bottom: 24px">
            量身打造私域直播体系，迅速连接潜在客户，提升业绩
          </div>
          <div style="color: #f5f8fa; font-size: 16px; margin-bottom: 40px">
            医美健康行业进入直播时代，大米智课凭借数百项功能满足医美在线推广、医疗培训、健康科普讲座等场景需求，商家可以通过直播的形式介绍自己的产品和服务，直接引流至线下门店或微信社群进行购买，实现营销与销售的完美结合。
          </div>
          <div class="icon">
            <div
              style="
                display: flex;
                flex-direction: column;
                align-items: center;
                margin: 0 15px;
              "
            >
              <div class="img">
                <img
                  style="width: 146px; height: 146px"
                  src="../assets/official/Group 301@2x2.png"
                  alt=""
                />
              </div>
            </div>
            <div
              style="
                display: flex;
                flex-direction: column;
                align-items: center;
                margin: 0 15px;
              "
            >
              <div class="img">
                <img
                  style="width: 146px; height: 146px"
                  src="../assets/official/Group 47994@2x2.png"
                  alt=""
                />
              </div>
            </div>
            <div
              style="
                display: flex;
                flex-direction: column;
                align-items: center;
                margin: 0 15px;
              "
            >
              <div class="img">
                <img
                  style="width: 146px; height: 146px"
                  src="../assets/official/Group 47993@2x2.png"
                  alt=""
                />
              </div>
            </div>
            <div
              style="
                display: flex;
                flex-direction: column;
                align-items: center;
                margin: 0 15px;
              "
            >
              <div class="img">
                <img
                  style="width: 146px; height: 146px"
                  src="../assets/official/Group 47995@2x2.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div
            @click="inquiry()"
            style="
              background-color: #0274f7;
              height: 44px;
              width: 140px;
              border-radius: 2px;
              text-align: center;
              line-height: 44px;
              margin-top: 20px;
              cursor: pointer;
            "
          >
            立即咨询
          </div>
        </div>
        <div class="right" v-if="classIndex == 4">
          <div style="font-size: 24px; margin-bottom: 24px">
            深度集成与高效管理的一站式学习平台
          </div>
          <div style="color: #f5f8fa; font-size: 16px; margin-bottom: 40px">
            大米智课通过深度集成和高效管理，打造一站式线上学习平台，该平台旨在提供全面而便捷的学习体验，使知识获取和技能提升变得更高效、更便捷，同时可显著降低机构教育培训成本，超过50%
          </div>
          <div class="icon">
            <div
              style="
                display: flex;
                flex-direction: column;
                align-items: center;
                margin: 0 15px;
              "
            >
              <div class="img">
                <img
                  style="width: 146px; height: 146px"
                  src="../assets/official/Group 301@2x3.png"
                  alt=""
                />
              </div>
            </div>
            <div
              style="
                display: flex;
                flex-direction: column;
                align-items: center;
                margin: 0 15px;
              "
            >
              <div class="img">
                <img
                  style="width: 146px; height: 146px"
                  src="../assets/official/Group 47994@2x3.png"
                  alt=""
                />
              </div>
            </div>
            <div
              style="
                display: flex;
                flex-direction: column;
                align-items: center;
                margin: 0 15px;
              "
            >
              <div class="img">
                <img
                  style="width: 146px; height: 146px"
                  src="../assets/official/Group 47993@2x3.png"
                  alt=""
                />
              </div>
            </div>
            <div
              style="
                display: flex;
                flex-direction: column;
                align-items: center;
                margin: 0 15px;
              "
            >
              <div class="img">
                <img
                  style="width: 146px; height: 146px"
                  src="../assets/official/Group 47995@2x3.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div
            @click="inquiry()"
            style="
              background-color: #0274f7;
              height: 44px;
              width: 140px;
              border-radius: 2px;
              text-align: center;
              line-height: 44px;
              margin-top: 20px;
              cursor: pointer;
            "
          >
            立即咨询
          </div>
        </div>
        <div class="right" v-if="classIndex == 5">
          <div style="font-size: 24px; margin-bottom: 24px">
            定制人才专属培训计划，提升培训的成效
          </div>
          <div style="color: #f5f8fa; font-size: 16px; margin-bottom: 40px">
            大米智课有效的解决了企业分支机构繁多、员工分布广泛的问题，打破了实地培训对人数的限制，降低了现场培训的高额成本。不仅如此，企业还能够构建起完备的培训课程评估系统，随时收集员工的学习数据以及获取相关反馈。
          </div>
          <div class="icon">
            <div
              style="
                display: flex;
                flex-direction: column;
                align-items: center;
                margin: 0 15px;
              "
            >
              <div class="img">
                <img
                  style="width: 146px; height: 146px"
                  src="../assets/official/Group 301@2x4.png"
                  alt=""
                />
              </div>
            </div>
            <div
              style="
                display: flex;
                flex-direction: column;
                align-items: center;
                margin: 0 15px;
              "
            >
              <div class="img">
                <img
                  style="width: 146px; height: 146px"
                  src="../assets/official/Group 47994@2x4.png"
                  alt=""
                />
              </div>
            </div>
            <div
              style="
                display: flex;
                flex-direction: column;
                align-items: center;
                margin: 0 15px;
              "
            >
              <div class="img">
                <img
                  style="width: 146px; height: 146px"
                  src="../assets/official/Group 47993@2x4.png"
                  alt=""
                />
              </div>
            </div>
            <div
              style="
                display: flex;
                flex-direction: column;
                align-items: center;
                margin: 0 15px;
              "
            >
              <div class="img">
                <img
                  style="width: 146px; height: 146px"
                  src="../assets/official/Group 47995@2x4.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div
            @click="inquiry()"
            style="
              background-color: #0274f7;
              height: 44px;
              width: 140px;
              border-radius: 2px;
              text-align: center;
              line-height: 44px;
              margin-top: 20px;
              cursor: pointer;
            "
          >
            立即咨询
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="bademon"
      style="
        position: fixed;
        top: 0;
        z-index: 999;
        height: 100vh;
        width: 100vw;
        background-color: rgba(204, 204, 204, 0.7);
      "
    ></div>
    <div
      v-if="bademon"
      style="
        width: 346px;
        height: 320px;
        background-color: #fff;
        position: fixed;
        top: 30%;
        left: calc(50% - 173px);
        z-index: 1000;

        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        border-radius: 10px;

        /* padding: 38px;
        box-sizing: border-box; */
      "
    >
      <i
        class="el-icon-close"
        style="position: absolute; top: 10px; right: 10px"
        @click="unInquiry()"
      ></i>
      <div
        style="font-size: 20px; color: rgba(51, 51, 51, 1); font-weight: 500"
      >
        免费定制专属网校
      </div>
      <el-select
        v-model="value"
        placeholder="请选择您所在的行业"
        style="height: 40px; width: 270px; margin: 24px 0 16px 0"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-input
        v-model="input"
        placeholder="请输入您的联系方式"
        style="height: 40px; width: 270px"
      ></el-input>
      <div
        style="
          height: 40px;
          width: 270px;
          font-size: 14px;
          color: #0274f7;
          margin: 10px 0 20px 0;
        "
      >
        提交即可获取30天免费试用
      </div>
      <el-button
        @click="submitPhone"
        type="primary"
        style="
          height: 40px;
          width: 270px;
          background-color: #0274f7;
          color: #fff;
        "
        >提交</el-button
      >
    </div>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import axios from 'axios'

export default {
  name: 'HelloWorld',
  data() {
    return {
      bademon: false,
      options: [
        {
          value: '知识付费',
          label: '知识付费',
        },
        {
          value: '兴趣培训',
          label: '兴趣培训',
        },
        {
          value: '大健康',
          label: '大健康',
        },
        {
          value: 'K12教育',
          label: 'K12教育',
        },
        {
          value: '企业培训',
          label: '企业培训',
        },
        {
          value: '医疗美容',
          label: '医疗美容',
        },
      ],
      value: '',
      input: '',
      classIndex: 1,
      classBgc: 'solution1',
      newsList: [],
      phoneNumber: 13195322273,
    }
  },

  created() {},
  destroyed() {},
  mounted() {},
  methods: {
    //提交留资信息
    submitPhone() {
      const ccc =
        /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/
      if (this.input && this.value && ccc.test(this.input)) {
        axios
          .get(
            'https://manager-api.mischool.com.cn' +
              '/official/mail?' +
              'mobile=' +
              this.input +
              '&industry=' +
              this.value
          )
          .then((res) => {
            if (res.data.code === 200) {
              console.log('发送成功')
              this.bademon = false
              this.$message.success('提交成功')
              this.input = ''
              this.value = ''
            }
          })
      } else {
        this.$message.error('请选择行业或输入手机号')
      }
    },
    // 打开留资弹窗
    inquiry() {
      this.bademon = true
    },
    // 关闭留资弹窗
    unInquiry() {
      this.bademon = false
    },
    handleSwitch(index) {
      this.classIndex = index
      this.classBgc = 'solution' + index
    },
  },
  beforeDestroy() {},
}
</script>
<style scoped lang="scss">
.solution1 {
  background-image: url('../assets/official/Group 48029@2x.png');
}
.solution2 {
  background-image: url('../assets/official/Group 48030@2x.png');
}
.solution3 {
  background-image: url('../assets/official/Group 48033@2x.png');
}
.solution4 {
  background-image: url('../assets/official/Group 48032@2x.png');
}
.solution5 {
  background-image: url('../assets/official/Group 48031@2x.png');
}
.solution {
  // background-image: url('../assets/official/image 119@2x.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  .solution-cover {
    width: 100%;
    height: 100%;
    // background-image: url('../assets/official/image 120@2x.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    display: flex;
    // justify-content: center;
    align-items: center;
    flex-direction: column;
    .title {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-family: 'PingFang SC-Medium', sans-serif;
      font-size: 36px;
      width: 100%;
      padding: 100px 0 60px 0;
    }
    .content2 {
      // width: 100%;
      height: 446px;
      // background-color: #fff;
      // padding: 0 118px;
      display: flex;
      align-items: center;
      .left {
        width: 280px;
        height: 100%;
        background-color: rgba(10, 13, 23, 0.7);
        .left-list {
          cursor: pointer;
          color: #fff;
          height: 50px;
          width: 240px;
          // background-color: #666;
          margin: 20px 20px;
          // text-align: center;
          line-height: 50px;
          padding-left: 50px;
          box-sizing: border-box;
          border-radius: 4px;
        }
        .left-active {
          background-image: linear-gradient(to right, #03a0fc, #0274f7);
        }
      }
      .right {
        width: 918px;
        height: 100%;
        background-color: rgba(10, 13, 23, 0.6);
        color: #fff;
        padding: 40px 60px 0 40px;
        box-sizing: border-box;
        .icon {
          display: flex;
          // justify-content: center;
          align-items: center;
          font-size: 20px;
        }
      }
    }
  }
}
</style>
